import { Component, OnInit,ViewChild} from '@angular/core';
import {
  GridDataResult,
  DataStateChangeEvent
} from '@progress/kendo-angular-grid';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { UserProfileService, RaService, DownloadService } from '../../core';
import { State } from '@progress/kendo-data-query';
import {modalComponent} from '../../common/component/modal/modal.component';


@Component({
  selector: 'app-rate-audit-summary-report',
  templateUrl: './rate-audit-summary-report.component.html',
  styleUrls: ['./rate-audit-summary-report.component.scss']
})
export class RateAuditSummaryReportComponent implements OnInit {
  public view: GridDataResult;
  public sorted: string = "";
  public pageSize:any;
  public state: State = {};
  public selectedAuditID:string="";
  public maxlength:boolean=false;

  constructor(private service: RaService, private downloadService:DownloadService,private dialogService: DialogService) {
      this.service.GetAuditListForSummaryReport(this.state)
      .subscribe(data=>{
        this.view = data;
        this.pageSize=data.total;
    });

  }

  ngOnInit() {
  }

  OnBuildReport(event){

    var count=0;

  this.view.data.forEach(element => {
    if(element.checked){
      count++;
      if(count<=200)
      {

            if(this.selectedAuditID=="")
              {
                this.selectedAuditID+= element.AuditID ;
              }
            else{
              this.selectedAuditID+= ","+element.AuditID ;
            }
         }
      else
        {
            this.maxlength=true;
            this.modalDetails();

        }
    }
    }
  );
 if(this.maxlength!=true){
   this.downloadService.downloadSummaryReport(this.selectedAuditID)
              .subscribe((data)=>{this.selectedAuditID="";},
                (err)=> {
                  console.log(err);

                }
              );
 }

  }



  public dataStateChange(state: DataStateChangeEvent): void {
      this.state = state;
      this.sorted = "";
      this.sorted = (state.sort.find(e =>  e.dir==='asc' ||e.dir=='desc' ) || {'field':''}).field;
        this.service.GetAuditListForSummaryReport(this.state).
      subscribe(data=>{
        this.view = data; });
    }

  public modalDetails()
  {
      this. dialogTitle="Summary audit report";
      this.dialogTextLine1="You can not select more than 200 runs for summary audit";
      this.dialogTextLine2="";
      this.primaryButtonText="Ok";
      this.secondaryButtonText="";
      this.showModal(event);
  }

   @ViewChild(modalComponent, { static: false }) modalController: modalComponent;
   public dialogTitle:string;
   public dialogTextLine1:string;
   public dialogTextLine2:string;
   public primaryButtonText:string;
   public secondaryButtonText:string;

    public openModal:boolean=false;
    public kendoDialog:boolean=true;


   public showModal(xyz: any):void {
    this.openModal=true;
    const dialog: DialogRef = this.dialogService.open({
          content:modalComponent
      });
    }

    public closeModals():void {
      this.kendoDialog=false;
      this.openModal=false;
   }


    public okButtonClick():void {
       this.maxlength=false;
      this.kendoDialog=false;
      this.openModal=false;
    }


}
